// extracted by mini-css-extract-plugin
export var formContainer = "_fe-0";
export var message = "_fe-1";